/**
 * PartisanshipModal popup used in G2024 page
 * Displays over the page when user selects 'ModeledParty' as a demographic option
 * See https://targetsmart.atlassian.net/browse/SE-1189
 **/
import React, { useState } from "react";

export default function PartisanshipModal({ onAcknowledge }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleAcknowledge = () => {
    if (isChecked) {
      onAcknowledge();
    } else {
      alert("Please check the box to proceed.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Important Notice</h2>
        <p>
          Before accessing the modeled partisanship data, please read the
          following carefully:
        </p>
        <p>
          TargetSmart’s partisanship modeling ranks voters according to their
          likely partisan leanings and is refined every year. While this model
          offers us a good general sense of early voting trends, variations in
          training data, survey collection methods, and modeling techniques for
          each iteration of our model may lead to confusion when comparing the
          model across election cycles. To help partially reduce the risk of
          misinterpretation, we recommend viewing modeled partisanship with the
          ‘percent turnout’ toggle selected.
        </p>
        <p>
          By checking this box, you acknowledge your understanding of these
          limitations and agree to proceed.
        </p>
        <div className="checkbox-container">
          <input
            type="checkbox"
            id="acknowledge"
            checked={isChecked}
            onChange={() => setIsChecked(!isChecked)}
          />
          <label htmlFor="acknowledge">
            I understand and wish to view modeled partisanship data.
          </label>
        </div>
        <button onClick={handleAcknowledge}>OK</button>
      </div>
    </div>
  );
}
